var LLRewardCheckAttempts = 0;
function displayAvailableLLRewards()
{
  if(jQuery('.points-total span').length && jQuery('.points-total span').html())
  {
    let LLPointsTotal = parseInt((jQuery('.points-total span').html()).replace(',', ''));
    if(LLPointsTotal)
    {
      var rewardsAmount = 0;
      var pointsAway = 0;
      var nextRewardAmount = 0;
      if(LLPointsTotal >= 4500)
      {
        rewardsAmount = 20;
      }
      else if(LLPointsTotal >= 2500)
      {
        pointsAway = 4500 - LLPointsTotal;
        nextRewardAmount = 20;
        rewardsAmount = 15;
      }
      else if(LLPointsTotal >= 1500)
      {
        pointsAway = 2500 - LLPointsTotal;
        nextRewardAmount = 15;
        rewardsAmount = 10;
      }
      else
      {
        pointsAway = 1500 - LLPointsTotal;
        nextRewardAmount = 10;
      }
        
      if(rewardsAmount)
      {
        // cart page
        let rewardsHTML = 'A $' + rewardsAmount + ' reward is available for you to redeem! ';
        jQuery('.ll-available-rewards:not(.ajaxcart-draw .ll-available-rewards)').html(rewardsHTML);

        // mini cart
        rewardsHTML = 'A $' + rewardsAmount + ' reward is available for you to redeem! Click <a class="rewards-list-opener" href="#">here</a> to redeem your reward. ';
        jQuery('.ajaxcart-draw .ll-available-rewards').html(rewardsHTML);
        jQuery('.rewards-list-opener').click(function(e){
          e.preventDefault();
          showRewardsListPopup();
        });
      }

      if(pointsAway)
      {
        let pointsAwayHTML = 'You are ' + pointsAway + ' points away from a $' + nextRewardAmount + ' reward.';
        jQuery('.ll-next-reward').html(pointsAwayHTML);
      }
        
    }
  }
  else if(LLRewardCheckAttempts < 10)
  {
    LLRewardCheckAttempts++;
    setTimeout(function(){
      displayAvailableLLRewards();
    }, 500);
  }
}

function showRewardsListPopup()
{
  console.log('showRewardsListPopup');

  $.magnificPopup.close();
  
  if(!jQuery('#marvylous-ll-modal').length)
  {
    //console.log('building popup');
    let llPopupHTML = '<div id="marvylous-ll-modal">';
    llPopupHTML += '<div class="lion-modal-and-screen">';
    llPopupHTML += '<div class="lion-screen lion-screen--light">';
    llPopupHTML += '<div class="lion-modal lion-modal--small lion-redeem-reward-modal">';
    llPopupHTML += '<div class="lion-modal__header">';
    llPopupHTML += '<div class="lion-modal__title"><span>Redeem Your Reward</span></div><a class="lion-modal__close-button">×</a>';
    llPopupHTML += '<div data-lion-rewards-list></div>';
    llPopupHTML += '<div class="lion-modal__disclaimer">Eligible for a reward? Once you click redeem you must use your code in this session before it expires.</div>';
    llPopupHTML += '</div>';
    llPopupHTML += '</div>';
    llPopupHTML += '</div>';
    llPopupHTML += '</div>';
    llPopupHTML += '</div>';
    //jQuery('#loyaltylion #lion-loyalty-panel-custom-css').append(llPopupHTML);
    jQuery('body').append(llPopupHTML);
    
    window.loyaltylion.ui.refresh();
    
    jQuery('.lion-modal__close-button, .lion-screen.lion-screen--light').click(function(){
      jQuery('#marvylous-ll-modal').remove();
    });
  }
  
}

jQuery(document).ready(function(){
  displayAvailableLLRewards();
});